<div class="v4-layout-field" [class.focus]="active">
  <div class="v4-layout-field-label flex flex-row items-center flex-1">
    <div class="relative mr-1">
      <span
        class="pay-type"
        [class.cash]="data.thirdparty_type === Platform.Ctrip && data.payment_type === 1"
        [class.advance]="data.thirdparty_type === Platform.Ctrip && data.payment_type === 0"></span>
      <img [src]="(data.thirdparty_type | thirdparty)?.icon_color" class="w-[18px] h-[18px] rounded-full" />
    </div>
    <div class="title-wrap flex flex-row items-center leading-tight" (click)="data.expand = !data.expand">
      <p class="house-title" [class.active]="active" nz-paragraph [nzEllipsis]="true" [nzEllipsisRows]="2">
        {{ data.house_info?.thirdparty_house_title }}
      </p>
      <!-- <div *ngIf="data.thirdparty_type === Platform.BOOKING" class="expand-icon" [class.up]="data.expand">
        <img src="/assets/icon/siderbar-down-arrow.svg" alt="" width="10" />
      </div> -->
    </div>
  </div>
  <div class="v4-layout-field-control !flex-none w-[120px]">
    <div class="v4-layout-field-row">
      <input type="number" nzSize="large" nz-input [placeholder]="data.placeholder" [(ngModel)]="data.stock" />
    </div>
  </div>
</div>

<ng-template #tooltipTpl>
  <div class="tooltip-panel">
    <p style="font-size: 14px; font-weight: bold; color: #000000; line-height: 1.5">
      {{ "calendar.sidebar.inventory.booking.min_stay" | translate }}
      <!-- 最短预定天数 -->
    </p>
    <p>
      {{ "calendar.sidebar.inventory.booking.min_stay_tip" | translate }}
      <!-- 打开后，如果订单中包含该日期，则订单的间夜数必须超过最短预定天数才允许下单。 -->
    </p>
    <br />
    <p style="font-size: 14px; font-weight: bold; color: #000000; line-height: 1.5">
      {{ "calendar.sidebar.inventory.booking.close_on_arrival" | translate }}
      <!-- 禁止当日入住 -->
    </p>
    <p>
      {{ "calendar.sidebar.inventory.booking.close_on_arrival_tip" | translate }}
      <!-- 打开后，该日期不允许作为订单中的第一天（入住日）。 -->
    </p>
  </div>
</ng-template>
